<template>
  <div class="zzzd_BEContainer">
    <div class="zzzd_BEWrapper">
      <div class="zzzd_steps">
        <div class="zzzd_circle el-icon-check active_icon"></div>
        <div class="zzzd_step active">入驻类型</div>
        <div class="zzzd_line"></div>
        <div class="zzzd_circle el-icon-check active_icon"></div>
        <div class="zzzd_step active">基础评估</div>
        <div class="zzzd_line"></div>
        <div class="zzzd_circle active">3</div>
        <div class="zzzd_step active">智能诊断</div>
        <div class="zzzd_line"></div>
        <div class="zzzd_circle">4</div>
        <div class="zzzd_step">诊断结果</div>
      </div>
      <div class="zzzd_loading">
        <img src="@/assets/imgs/zzzd/分组 15.png" alt="">
      </div>
      <div class="zzzd_desc">
        <span>诊断中，请稍候...</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: 0,
      timer:null
    };
  },
  methods: {
  
  },
  mounted(){
    this.timer =  setTimeout(() => {
      //  this.$router.push({path:'/diagnose/result'})
       this.$router.push({path:'/diagnose/ECommerce/evaluateResult'})
    }, 2000);
  
  },
  destroyed(){
    clearTimeout(this.timer)
  }
};
</script>

<style lang="scss" scoped>
.zzzd_BEContainer {
  background: #ebecef;
  width: 100%;
  min-height: 100%;
  border-top: 1px solid #ebecef;
  padding-bottom: 29px;
  .zzzd_BEWrapper {
    width: 1190px;
    min-height: 100%;
    background: #fff;
    height: 90%;
    margin:29px auto 0;
    padding: 40px 27px;
    .zzzd_steps {
      display: flex;
      .zzzd_circle {
        width: 32px;
        height: 32px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        font-family: HelveticaNeue;
        line-height: 32px;
        text-align: center;
        border-radius: 50%;
        border: 1px solid rgba(0, 0, 0, 0.15);
        &.active {
          background: #D7443F;
          border: 1px solid #D7443F;
          color: #fff;
        }
        &.active_icon {
          // background: #D7443F;
          border: 1px solid #D7443F;
          color: #D7443F;
        }
      }
      .zzzd_step {
        width: 64px;
        height: 24px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        line-height: 24px;
        margin: 4px 8px;
        &.active {
          color: #000;
        }
      }
      .zzzd_line {
        width: 192px;
        height: 1px;
        background: rgba(0, 0, 0, 1);
        opacity: 0.15;
        margin-top: 17px;
        margin-right: 15px;
        margin-left: 22px;
      }
    }
    .zzzd_loading{
      animation:donghua  0.5s  ease-in-out  infinite  alternate;
      img{
        margin: 100px auto;
        margin-bottom: 20px;
      }
      @keyframes  donghua{
          from{
              transform:translateY(0)
          }
          to{
              transform:translateY(40px)
          }
      }
    }
    .zzzd_desc{
        margin-top: 47px;
        font-size:16px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:22px;
        text-align: center;
      }
  }
}
</style>